<template>
    <div id="project">
        <div id="projectTitle">
            <span>{{ getProject.title }} </span>
            <router-link :to="getParentList">&#xF0011;</router-link>
        </div>
        <transition appear name="appear">
            <div id="imageList" v-if="render">
                <div v-for="image in getImages" class="imageContainer">
                    <div class="images" v-if="!image.middleImage">
                        <div class="imageElement">
                            <img
                                :src="
                                    image.image.endsWith('gif')
                                        ? image.image
                                        : image.thumbnail_big
                                "
                                :class="getClasses(image)"
                            />
                        </div>
                        <div class="imageElement" v-if="image.secondImage">
                            <img
                                :src="
                                    image.secondImage.image.endsWith('gif')
                                        ? image.secondImage.image
                                        : image.secondImage.thumbnail_big
                                "
                                :class="getClasses(image.secondImage)"
                            />
                        </div>
                        <div
                            class="imageElement"
                            v-if="
                                image.secondImage &&
                                    image.secondImage.middleImage
                            "
                        >
                            <img
                                :src="
                                    image.secondImage.secondImage.image.endsWith(
                                        'gif'
                                    )
                                        ? image.secondImage.secondImage.image
                                        : image.secondImage.secondImage
                                              .thumbnail_big
                                "
                                :class="
                                    getClasses(image.secondImage.secondImage)
                                "
                            />
                        </div>
                    </div>
                    <div
                        v-if="image.text"
                        class="imageText"
                        v-html="image.text"
                    ></div>
                </div>
            </div>
        </transition>
        <transition appear name="appear">
            <div id="projectInfos" v-if="render">
                <div>{{ getProject.text }}</div>
                <div v-for="info in getProject.infos" v-html="info.text"></div>
                <a
                    :href="getProject.link"
                    target="_blank"
                    v-html="getProject.link_text"
                ></a>
            </div>
        </transition>
        <transition appear name="appear">
            <div id="spinner" v-if="!render">
                <div class="lds-spinner" v-if="!render">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { store } from "@/centralStore";
export default {
    name: "ProjectDetail",
    data() {
        return {
            store: store.state,
            render: false
        };
    },
    computed: {
        getProject() {
            if (this.store.allProjects.length) {
                return this.store.allProjects.find(
                    p => p.slug == this.$route.params.slug
                );
            } else {
                return {};
            }
        },
        getImages() {
            let images = [];
            let pairmark = false;
            let pairID = 0;
            if (this.getProject.images) {
                this.getProject.images.forEach(i => {
                    if (!pairmark) {
                        images.push(i);
                        pairID = i.id;
                    } else {
                        images.find(im => im.id == pairID).secondImage = i;

                        if (i.is_paired_with_next) {
                            i.middleImage = true;
                            images.push(i);
                            pairID = i.id;
                        } else {
                            pairmark = false;
                        }
                    }
                    if (i.is_paired_with_next) {
                        pairmark = true;
                    }
                });
            }
            return images;
        },
        getParentList() {
            if (Object.keys(this.getProject).length === 0) {
                return {};
            }
            let category = this.getProject.category.name;
            console.log(category);
            if (
                category == "Book" ||
                category == "Periodical" ||
                category == "Magazine"
            ) {
                return { name: "project-list-books" };
            } else if (category == "Website") {
                return { name: "project-list-websites" };
            } else if (category == "Typeface (Project)") {
                return { name: "project-list-typefaces" };
            } else {
                return { name: "project-list-identities" };
            }
        }
    },
    methods: {
        getClasses(image) {
            return {
                websiteImage: image.is_website,
                lightBorder: image.border == "LI",
                darkBorder: image.border == "DA"
            };
        },
        waitForImages() {
            const imageElements = this.getProject.images;

            const promises = imageElements.map(src => {
                return new Promise(resolve => {
                    const img = new Image();
                    img.src = src;
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            });

            Promise.all(promises).then(() => {
                const myself = this;
                setTimeout(function() {
                    myself.render = true;
                }, 200);
            });
        }
    },
    mounted() {
        const myself = this;
        setTimeout(function() {
            myself.waitForImages();
        }, 200);
    }
};
</script>
<style scoped>
a {
    color: #969696;
    text-decoration: none;
}
@media screen and (min-width: 768px) {
    a:hover {
        color: white;
    }
}
#project,
#imageList,
.imageContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    max-width: 100%;
}
#project {
    gap: 2rem;
    padding-bottom: 2rem;
    margin-top: -1.5rem;
}
#imageList {
    margin: 0 1rem;
}
.images {
    display: flex;
    gap: 1rem;
    max-width: 100%;
}
.images.paired img {
    max-width: calc(50vw - 1.5em);
}

.images img {
    max-height: 75vh;
    max-width: 100%;
}

.imageElement {
    flex: 1 1 0; /* ← das ist der Schlüssel */
    min-width: 0;
    object-fit: cover;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
}
#projectInfos {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 2rem;
}
.imageText,
#projectInfos {
    max-width: 46rem;
    text-align: center;
}
.imageText {
    margin-bottom: 1rem;
}
#projectTitle {
    text-align: center;
    margin: 0 1em;
}
#projectTitle > span {
    text-align: center;
    margin-right: 0.5em;
}
.lightBorder {
    border: 0.5px solid #565656;
    box-sizing: border-box;
}

.darkBorder {
    border: 0.5px solid #202020;
    box-sizing: border-box;
}
.lds-spinner {
    color: official;
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    transform: scale(0.5);
}

.lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
}

.lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}

@keyframes lds-spinner {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
.appear-enter-active,
.appear-leave-active {
    transition: opacity 0.5s;
}

.appear-enter,
.appear-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}
</style>
